export default __webpack_public_path__ + "static/media/deals.f1249b37.svg";